import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import { initAnalytics } from 'Services/analytics';

// styles
import 'disco-ui/dist/components.css';
import 'react-vis/dist/style.css';
import 'Styles/index.css';

// RootComponent
import App from './app.js';

const root = createRoot(document.getElementById('root'));

initAnalytics().catch(err => {
  console.error('Failed to initialize Amplitude analytics', err);
});

root.render(<App />);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
